'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // Lib


// Utils


// Components


// Selector


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = require('react-dnd');

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _memoizeOne = require('memoize-one');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _dragLayerUtil = require('./dragLayerUtil');

var _renderThrottleDecorator = require('../../utils/milanoteRecompose/renderThrottleDecorator');

var _renderThrottleDecorator2 = _interopRequireDefault(_renderThrottleDecorator);

var _LineDragPreview = require('../../element/line/LineDragPreview');

var _LineDragPreview2 = _interopRequireDefault(_LineDragPreview);

var _LineControlPointDragPreview = require('../../element/line/LineControlPointDragPreview');

var _LineControlPointDragPreview2 = _interopRequireDefault(_LineControlPointDragPreview);

var _ConnectedLineDragPreview = require('../../element/line/ConnectedLineDragPreview');

var _ConnectedLineDragPreview2 = _interopRequireDefault(_ConnectedLineDragPreview);

var _ElementPositioner = require('../../element/ElementPositioner');

var _ElementPositioner2 = _interopRequireDefault(_ElementPositioner);

var _gridSizeSelector = require('../../utils/grid/gridSizeSelector');

var _dragModifierKeysSelector = require('../../utils/dnd/modifierKeys/dragModifierKeysSelector');

var _dragModifierKeysConstants = require('../../utils/dnd/modifierKeys/dragModifierKeysConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORIGIN = { x: 0, y: 0 };

var mapStateToProps = function mapStateToProps(state) {
    return {
        gridSize: (0, _gridSizeSelector.getGridSize)(state)
    };
};

var lineDragLayerCollect = function lineDragLayerCollect(monitor) {
    return {
        itemType: monitor.getItemType(),
        item: monitor.getItem(),
        offsetDiff: monitor.getDifferenceFromInitialOffset()
    };
};

var DraggedLineControlPointPreview = function DraggedLineControlPointPreview(_ref) {
    var item = _ref.item,
        offsetDiff = _ref.offsetDiff,
        gridSize = _ref.gridSize;
    return _react2.default.createElement(
        _ElementPositioner2.default,
        { elementId: item.id },
        _react2.default.createElement(_LineControlPointDragPreview2.default, { elementId: item.id, offsetDiff: offsetDiff, pos: item.pos, gridSize: gridSize })
    );
};

var mapStateToDraggedLineEdgePreviewProps = function mapStateToDraggedLineEdgePreviewProps(state) {
    return {
        shouldSnapToAngle: (0, _dragModifierKeysSelector.getDragModifierKeys)(state).get(_dragModifierKeysConstants.MODIFIER_KEYS.shiftKey)
    };
};
var DraggedLineEdgePreview = function DraggedLineEdgePreview(_ref2) {
    var item = _ref2.item,
        offsetDiff = _ref2.offsetDiff,
        gridSize = _ref2.gridSize,
        shouldSnapToAngle = _ref2.shouldSnapToAngle;
    return _react2.default.createElement(
        _ElementPositioner2.default,
        { elementId: item.id },
        _react2.default.createElement(_LineDragPreview2.default, { elementId: item.id, draggedEdge: item.edge, offsetDiff: offsetDiff, pos: item.pos,
            shouldSnapToAngle: shouldSnapToAngle, gridSize: gridSize })
    );
};
DraggedLineEdgePreview = (0, _reactRedux.connect)(mapStateToDraggedLineEdgePreviewProps)(DraggedLineEdgePreview);

/**
 * memoizeOne memoizes only the last invocation of the method, thus ensuring the memoize cache doesn't grow out of
 * control.
 */
var getNotDraggedConnectedElementIds = (0, _memoizeOne2.default)(function (connectingElementIds, draggedElementIds) {
    return (0, _lodash.difference)(connectingElementIds, draggedElementIds);
});

var mapStateToDraggedConnectedElementProps = function mapStateToDraggedConnectedElementProps(state) {
    return {
        copyDrag: (0, _dragModifierKeysSelector.getDragModifierKeys)(state).get(_dragModifierKeysConstants.MODIFIER_KEYS.altKey)
    };
};
var DraggedConnectedElement = function DraggedConnectedElement(_ref3) {
    var item = _ref3.item,
        offsetDiff = _ref3.offsetDiff,
        gridSize = _ref3.gridSize,
        copyDrag = _ref3.copyDrag;

    // FIXME Hack to keep lines in place when the altKey is pressed (as the element is being copied, not moved)
    // This should probably be moved into the dnd library somehow
    var offset = copyDrag ? ORIGIN : offsetDiff;

    // If a connected element is also selected then it will also be dragged so shouldn't be included in the connected
    // element drag preview (but instead in the selected element drag preview).
    var notDraggedConnectedElementIds = getNotDraggedConnectedElementIds(item.connectingElementIds, item.draggedElementIds);

    return _react2.default.createElement(
        'div',
        null,
        notDraggedConnectedElementIds.map(function (connectingElementId) {
            return _react2.default.createElement(
                _ElementPositioner2.default,
                { key: connectingElementId, elementId: connectingElementId },
                _react2.default.createElement(_ConnectedLineDragPreview2.default, { elementId: connectingElementId, draggedElementIds: item.draggedElementIds,
                    offsetDiff: offset, gridSize: gridSize })
            );
        })
    );
};
DraggedConnectedElement = (0, _reactRedux.connect)(mapStateToDraggedConnectedElementProps)(DraggedConnectedElement);

var LineDragLayer = (_dec = (0, _reactDnd.DragLayer)(lineDragLayerCollect), _dec2 = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (0, _renderThrottleDecorator2.default)(_class = _dec2(_class = function (_React$Component) {
    _inherits(LineDragLayer, _React$Component);

    function LineDragLayer() {
        _classCallCheck(this, LineDragLayer);

        return _possibleConstructorReturn(this, (LineDragLayer.__proto__ || Object.getPrototypeOf(LineDragLayer)).apply(this, arguments));
    }

    _createClass(LineDragLayer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _dragLayerUtil.isLineAffectedByDrag)(nextProps.item, nextProps.itemType) || (0, _dragLayerUtil.isLineAffectedByDrag)(this.props.item, this.props.itemType);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                itemType = _props.itemType,
                offsetDiff = _props.offsetDiff;

            if (!(offsetDiff && (0, _dragLayerUtil.isLineAffectedByDrag)(item, itemType))) return null;

            var content = null;
            if ((0, _dragLayerUtil.isDraggingLineEdge)(itemType)) {
                content = _react2.default.createElement(DraggedLineEdgePreview, this.props);
            } else if ((0, _dragLayerUtil.isDraggingLineControlPoint)(itemType)) {
                content = _react2.default.createElement(DraggedLineControlPointPreview, this.props);
            } else {
                content = _react2.default.createElement(DraggedConnectedElement, this.props);
            }

            return _react2.default.createElement(
                'div',
                { className: 'LineDragLayer' },
                content
            );
        }
    }]);

    return LineDragLayer;
}(_react2.default.Component)) || _class) || _class) || _class);


DraggedLineControlPointPreview.propTypes = DraggedLineEdgePreview.propTypes = DraggedConnectedElement.propTypes = LineDragLayer.propTypes = {
    item: _propTypes2.default.object,
    itemType: _propTypes2.default.string,
    gridSize: _propTypes2.default.number,
    offsetDiff: _propTypes2.default.object
};

exports.default = LineDragLayer;


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/dnd/LineDragLayer.js
// module id = 1691
// module chunks = 0